import { h } from 'preact';

import Skeleton from '@mui/material/Skeleton';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';

import FormAndList from '../../components/formAndList.jsx';
import { PropertiesTable } from './_common.js';
import LazyPropertyRecord from '../../components/propertyRecord/lazyPropertyRecord.jsx';

function LazyOrganization(_props) {
  const title = <Skeleton width={120} />;
  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ mt: -4 }}
      >
        <Skeleton width={'100%'} height={48} />
      </AppBar>
      <FormAndList
        listTitle={title}
        formTitle={title}
        form={
          <>
            <Skeleton height={56} width={223} />
            <Divider />
            <Skeleton height={37} width={101} />
          </>
        }
        list={
          <PropertiesTable>
            {Array(7)
              .fill(null)
              .map((_, index) => (
                <LazyPropertyRecord key={index} />
              ))}
          </PropertiesTable>
        }
      />
    </>
  );
}

export default LazyOrganization;
